import { FC } from "react";
export const Footer:FC = () => {
  return (
    <footer className="footer">
      <img className="warn_pc" src="/resources/html/images/warn.png" alt="禁止酒駕 酒後不開車 安全有保障" />
      <img className="warn_mb" src="/resources/html/images/warn_mb.jpg" alt="禁止酒駕 酒後不開車 安全有保障" />
    </footer>
  );
};
